export const LogoutIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.93359 5.03992C6.14026 2.63991 7.3736 1.65991 10.0736 1.65991H10.1603C13.1403 1.65991 14.3336 2.85325 14.3336 5.83325V10.1799C14.3336 13.1599 13.1403 14.3533 10.1603 14.3533H10.0736C7.3936 14.3533 6.16026 13.3866 5.94026 11.0266"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0007 8H2.41406"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.90131 5.7666L1.66797 7.99994L3.90131 10.2333"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
